<div class="top">
    <div class="header">
        <h1 align="center">Shop From Indian Online Sites</h1>
    </div>
    <div class="vc_empty_space" style="height: 30px;"><span class="vc_empty_space_inner"></span>
    </div>
    <div class="header1">
        <h5 align="center">
            Shop Anything From Anywhere In India. Below Is Just A Guide. Looking For More Options Or Indian Store
            Recommendations, Tailoring Or Package Pick-Up Services? Or Need Something Else From India?
        </h5>
        <p align="center">Reach us now via WhatsApp, Facebook or Signup!</p>
    </div>
    <div class="card-container" style="margin-top: 70px;">
        <a class="card" target="_blank" rel="noopener" href="https://www.myntra.com">
            <img src="assets\Images\Group 39.png" height="53" width="173">
        </a>

        <a class="card" target="_blank" rel="noopener" href="https://www.amazon.com">
            <img src="assets\Images\Group 40.png" height="53" width="173">
        </a>

        <a class="card" target="_blank" rel="noopener" href="https://www.flipkart.com/">
            <img src="assets\Images\Group 42.png" height="53" width="173">
        </a>
        <a class="card" target="_blank" rel="noopener" href="https://www.ajio.com">
            <img src="assets\Images\Group 47.png" height="53" width="173">
        </a>

        <a class="card" target="_blank" rel="noopener" href="https://www.fabindia.com/">
            <img src="assets\Images\Group 46.png" height="53" width="173">
        </a>
    </div>
    <div class="card-container">
        <a class="card" target="_blank" rel="noopener" href="https://www.limeroad.com/">
            <img src="assets\Images\Group 38.png" height="53" width="173">
        </a>

        <a class="card" target="_blank" rel="noopener" href="https://www.pepperfry.com/">
            <img src="assets\Images\Group 41.png" height="53" width="173">
        </a>

        <a class="card" target="_blank" rel="noopener" href="https://www.nykaa.com/">
            <img src="assets\Images\Group 43.png" height="53" width="173">
        </a>
        <a class="card" target="_blank" rel="noopener" href="https://paytmmall.com/">
            <img src="assets\Images\Group 44.png" height="53" width="173">
        </a>

        <a class="card" target="_blank" rel="noopener" href="https://www.snapdeal.com/">
            <img src="assets\Images\Group 45.png" height="53" width="173">
        </a>
    </div>
    <!-- <div class="card-container">
            <a class="card" target="_blank" rel="noopener" href="https://www.limeroad.com/">
                <img src="assets\Images\chumbak.png" height="53" width="173">
            </a>
    
            <a class="card" target="_blank" rel="noopener" href="https://www.pepperfry.com/">
                <img src="assets\Images\saree-dot-com.png" height="53" width="173">
            </a>
    
            <a class="card" target="_blank" rel="noopener" href="https://www.nykaa.com/">
                <img src="assets\Images\jabong.png" height="53" width="173">
            </a>
            <a class="card" target="_blank" rel="noopener" href="https://paytmmall.com/">
                <img src="assets\Images\ecret-label.jpg.png" height="53" width="173">
            </a>
    
            <a class="card" target="_blank" rel="noopener" href="https://www.snapdeal.com/">
                <img src="assets\Images\Group 45.png" height="53" width="173">
            </a>
        </div> -->
    <div class="black" style="margin-bottom: 3rem;">
        <div>
            <h4>For More Latest Indian Deals, Sales, Discounts Join Our Facebook Group</h4>
            <a href="https://www.facebook.com/groups/ShopFromIndiaShipWorldWide/" target="_blank"
                style="text-align: center;">Shop & Ship from India
                – https://www.facebook.com/groups/ShopFromIndiaShipWorldWide/</a>
        </div>
    </div>
    
    <app-footer></app-footer>
</div>